/*  Shared  */
import { Payload } from 'application/Shared/Helpers';

/* NPM */
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import i18n from 'i18n';

dayjs.extend(advancedFormat);

const { t } = i18n;

export const handleRows = async (rows, clientId, getUsers, setRowMap) => {
    if (!rows?.length) {
        return;
    }
    const rowMap = {};

    const applications = rows.map((row) => row.application);
    const businessOwnerIds = applications
        .map((row) => row.businessOwnerPlatformUserId)
        .filter((row) => row != null);
    const ids = Payload.idString([...new Set(businessOwnerIds)]);

    const params = {
        id: ids,
        platformTenantId: clientId
    };

    const { userData } = await getUsers({ params });

    const ownersMap = Payload.responseMap(userData, 'id');

    rows.forEach((row) => {
        const { id } = row;
        const owner = ownersMap[row.application.businessOwnerPlatformUserId];

        let ownerName = t('Common.not_assigned');
        if (row.application.noBusinessOwnerRequired) {
            ownerName = t('Common.not_required');
        } else if (row.application.managedByPartner) {
            ownerName = t('Common.managed_by_partner');
        } else if (row.application.managed3rdParty) {
            ownerName = t('Common.managed_by_3rd_party');
        } else if (owner) {
            ownerName = `${owner.firstName} ${owner.lastName}`;
        }

        const alerting = row.alerting
            ? t('ContractManagement.alertSet')
            : t('ContractManagement.alertNotSet');

        let type;
        let renewalDate = new Date(row.renewalDate);
        const options = {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit'
        };

        if (row.type === 'month') {
            type = t('ContractManagement.monthToMonthContract');
            renewalDate = t('ContractManagement.monthlyOnTheDay', {
                day: dayjs(renewalDate).format('Do')
            });
        }
        if (row.type === 'renew') {
            type = t('ContractManagement.renewalContract');
            renewalDate = renewalDate.toLocaleDateString(undefined, options);
        }

        const { users } = row;
        const userNames = users
            .filter((user) => user.active)
            .map((user) => `${user.firstName} ${user.lastName}`);
        const tcv = `$${row.tcv}`;

        rowMap[id] = {
            ...row,
            alerting,
            ownerName,
            renewalDate,
            tcv,
            type,
            userNames
        };
    });
    setRowMap(rowMap);
};

export const csvFields = [
    { key: 'application.name', label: t('Common.app_name') },
    { key: 'ownerName', label: t('Common.business_owner') },
    { key: 'alerting', label: t('Common.alerting') },
    { key: 'type', label: t('Common.type') },
    { key: 'renewalDate', label: t('Common.contract_date') },
    { key: 'tcv', label: t('Common.tcv') },
    { key: 'subscribedUsers', label: t('Common.subscriptions') },
    { key: 'activeUsers', label: t('Common.active_user_count') },
    { key: 'userNames', label: t('Common.active_users') }
];
